import { render, staticRenderFns } from "./ConfirmQuestion.vue?vue&type=template&id=38c6b88c"
import script from "./ConfirmQuestion.vue?vue&type=script&lang=js"
export * from "./ConfirmQuestion.vue?vue&type=script&lang=js"
import style0 from "./ConfirmQuestion.vue?vue&type=style&index=0&id=38c6b88c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports